<template>
  <Drawer
    width="400"
    :title="`${openedTask ? '编辑' : '新增'}任务`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <div class="formItem">
          <div class="formItem-left">
            <FormItem label="任务标题" prop="title">
              <Input
                v-model="formItem.title"
                clearable
                placeholder="请输入任务标题"
              >
              </Input>
            </FormItem>
            <FormItem label="任务内容" prop="content">
              <Input
                v-model="formItem.content"
                type="textarea"
                placeholder="请输入任务内容..."
              />
            </FormItem>
            <FormItem label="任务类型" prop="type">
              <RadioGroup v-model="formItem.type">
                <Radio label="MonthlySalesPlan">
                  <span>月度销售计划</span>
                </Radio>
                <Radio label="MonthlyReceivePlan">
                  <span>月度回款计划</span>
                </Radio>
                <Radio label="SalesWeeklyReport">
                  <span>销售周报</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="主要负责人" prop="mainResponsible">
              <Select
                v-model="formItem.mainResponsible"
                filterable
                clearable
                @on-change="choseMainResponsible"
              >
                <Option
                  v-for="option in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="参与人" prop="involveMember">
              <Select
                v-model="formItem.involveMember"
                filterable
                clearable
                multiple
                @on-change="choseInvolveMemberList"
              >
                <Option
                  v-for="option in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
        </div>
        <div class="bottom-button">
          <FormItem style="margin-right: 20px">
            <Button type="primary" @click="handleSubmit('formItem')"
              >保存</Button
            >
          </FormItem>
          <Button
            v-if="openedTask && user.superAdmin"
            @click="delSalesModal = true"
            type="error"
            ghost
            >删除</Button
          >
        </div>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "EditTaskDrawer",
  data() {
    return {
      drawerOpened: false,
      openedTask: null,
      formItem: {
        title: null,
        mainResponsible: null,
        involveMember: [],
        type: null,
        content: null,
      },
      involveMemberList: [],
      ruleValidate: {
        title: [
          { required: true, message: "任务标题为必填", trigger: "submit" },
        ],
        content: [
          { required: true, message: "任务内容必填", trigger: "submit" },
        ],
        type: [
          { required: true, message: "任务类型为必填项", trigger: "submit" },
        ],
        mainResponsible: [
          { required: true, message: "主要负责人必填项", trigger: "submit" },
        ],
        // receivedAt: [
        //   {
        //     required: true,
        //     message: "到账日期为必填项",
        //     trigger: "submit",
        //     type: "date",
        //   },
        // ],
        // receivedBy: [
        //   { required: true, message: "收款人为必填项", trigger: "submit" },
        // ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
      userList: (state) => state.user.userList,
    }),
  },
  methods: {
    ...mapActions({
      getUsers: "user/getUsersAction",
      createTask: "task/createTaskAction",
      updateTask: "task/updateTaskAction",
    }),
    async openDrawer(task) {
      this.openedTask = null;
      await this.getUsers({ limit: 0 });
      this.$refs["formItem"].resetFields();

      if (task) {
        this.openedTask = task;
        this.formItem.title = task.title;
        this.formItem.content = task.content;
        this.formItem.type = task.type;
        this.formItem.mainResponsible = task.mainResponsible._id;
        this.formItem.involveMember = task.involveMember.map((x) => x._id);
      }
      this.drawerOpened = true;
    },
    async searchUser(searschText) {
      let api = {};
      if (searschText && searschText.trim() !== "") {
        api.userName = searschText;
      } else {
        delete api.userName;
      }
      try {
        await this.getUsers(api);
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    choseMainResponsible(mainResponsible) {
      if (mainResponsible) {
        this.formItem.mainResponsible = mainResponsible;
      } else {
        delete this.formItem.mainResponsible;
      }
    },
    choseInvolveMemberList(involveMember) {
      if (involveMember.length > 0) {
        this.formItem.involveMember = involveMember;
      } else {
        delete this.formItem.involveMember;
      }
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedTask) {
              await this.updateTask({
                id: this.openedTask._id,
                data: this.formItem,
              });
            } else {
              await this.createTask(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>